module.exports = __webpack_public_path__ + "static/media/onboarding-1.33916d5f.png";